import React, { useState } from 'react';
import GearIcon from '@bufferapp/ui/Icon/Icons/Gear';
import HeartOutlineIcon from '@bufferapp/ui/Icon/Icons/HeartOutline';
import RefreshIcon from '@bufferapp/ui/Icon/Icons/Refresh';

import { useAppSelector, useAppDispatch, history } from '~/store';
import { selectGenerateContentLimits } from '~/ai/state/aiLimits/slice';
import {
  selectGeneratedIdeas,
  clearIdeas,
} from '~/ai/state/contentIdeation/slice';
import { generateIdeas } from '~/ai/state/contentIdeation/thunks';
import { getPrompt } from '~/ai/helpers/localStorage';
import { Credits } from '~/ai/components/GenerateIdeasButton/Credits';
import { ErrorMessage } from '~/ai/components/GenerateIdeasButton/ErrorMessage';

import * as Styled from './styles';

const LoadingState = () => (
  <Styled.SkeletonBoxWrapper>
    <Styled.SkeletonBox style={{ width: '80%' }} />
    <Styled.SkeletonBox style={{ width: '90%' }} />
    <Styled.SkeletonBox style={{ width: '83%' }} />
    <Styled.SkeletonBox style={{ width: '50%' }} />
    <Styled.SkeletonBox style={{ width: '80%' }} />
  </Styled.SkeletonBoxWrapper>
);

/**
 *
 */
const GeneratedIdea = ({ onUpgrade }: { onUpgrade: () => void }) => {
  const [animateButton, setAnimateButton] = useState(false);

  const dispatch = useAppDispatch();

  const { canGenerateContent } = useAppSelector((state) =>
    selectGenerateContentLimits(state)
  );

  const { generatedIdeas, generateIdeasLoading, generateIdeasError } =
    useAppSelector((state) => selectGeneratedIdeas(state));

  const onTryAnother = () => {
    if (canGenerateContent) {
      dispatch(
        generateIdeas({
          prompt: getPrompt(),
          cta: 'publish-ideas-contentIdeationWidget-tryAnother-1',
        })
      );
    } else {
      setAnimateButton(true);
      setTimeout(() => setAnimateButton(false), 500);
    }
  };

  const onUseIt = () => {
    const idea = generatedIdeas?.[0];
    history.push(`/content/new?text=${idea}`);
  };

  const onCustomize = () => {
    if (canGenerateContent) {
      dispatch(clearIdeas());
    } else {
      onUpgrade();
    }
  };

  return generatedIdeas ? (
    <Styled.Wrapper>
      <Styled.CustomizeButton onClick={onCustomize}>
        <GearIcon size="smedium" />
        Customize
      </Styled.CustomizeButton>
      <Styled.IdeaWrapper>
        {generateIdeasLoading ? (
          <LoadingState />
        ) : (
          <Styled.Idea loading={generateIdeasLoading}>
            {generatedIdeas[0]}
          </Styled.Idea>
        )}
        <Styled.Buttons>
          {generateIdeasLoading ? (
            <Styled.LoadingMessage>
              <RefreshIcon />
              Generating another idea...
            </Styled.LoadingMessage>
          ) : (
            <>
              <Styled.Button
                onClick={onTryAnother}
                disabledStyles={!canGenerateContent}
              >
                <RefreshIcon />
                Try Another
              </Styled.Button>
              <Styled.Divider />
              <Styled.ButtonPrimary onClick={onUseIt}>
                <HeartOutlineIcon />
                Use it
              </Styled.ButtonPrimary>
            </>
          )}
        </Styled.Buttons>
      </Styled.IdeaWrapper>
      {generateIdeasError && <ErrorMessage message={generateIdeasError} />}
      <Styled.ErrorMessageContainer animate={animateButton}>
        <Credits onUpgrade={onUpgrade} />
      </Styled.ErrorMessageContainer>
    </Styled.Wrapper>
  ) : null;
};

export { GeneratedIdea };
